//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const Appointments = createAsyncThunk(
  "Appointments",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingAppointments(""));
      const response = await UsePortalApi(
        `Patient/Appointments`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
        response[0].hasOwnProperty('entry') ? dispatch(gettingAppointmentsSuccess(response[0].entry)) : dispatch(gettingAppointmentsClear())
      } else {
        dispatch(
          gettingAppointmentsFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingAppointmentsFailed(error));
    }
  }
);
const AppointmentsSlice = createSlice({
  name: "Appointments",
  initialState: {
    AppointmentsData: null,
    isAppointmentsLoading: false,
    isAppointmentsError: false,
  },
  reducers: {
    gettingAppointments: (state, action) => {
      state.AppointmentsData = null;
      state.isAppointmentsLoading = true;
      state.isAppointmentsError = false;
    },
    gettingAppointmentsSuccess: (state, action) => {
      console.log(action.payload ,"AppointmentsData11")
      state.AppointmentsData = action.payload;
      state.isAppointmentsLoading = false;
      state.isAppointmentsError = false;
    },
    gettingAppointmentsFailed: (state, action) => {
      state.AppointmentsData = null;
      state.isAppointmentsLoading = false;
      state.isAppointmentsError = true;
    },
    gettingAppointmentsClear: (state, action) => {
      state.AppointmentsData = null;
      state.isAppointmentsLoading = false;
      state.isAppointmentsError = false;
    },
  },
});
export const {
  gettingAppointments,
  gettingAppointmentsSuccess,
  gettingAppointmentsFailed,
  gettingAppointmentsClear,
} = AppointmentsSlice.actions;
export default AppointmentsSlice.reducer;
